var path = '/modules/tickets/templates/views/pages/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/tickets/templates/views/pages/list.tpl.html
// module id = 2169
// module chunks = 1